import { TagModel } from "@app/shared/services/gtm/model/tag.model";

export class FormFieldTagModel extends TagModel {
  formFieldName: string;
}
